const ID_TOKEN_KEY = "lamusica_cms_user_token";

const getToken = () => {
  return localStorage.getItem(ID_TOKEN_KEY);
};

const saveToken = (token) => {
  localStorage.setItem(ID_TOKEN_KEY, token);
};

const destroyToken = () => {
  localStorage.removeItem(ID_TOKEN_KEY);
};

export default { getToken, saveToken, destroyToken };
